/**
 * Environment Configuration
 * Centralized configuration for different environments
 */

const config = {
  development: {
    apiUrl: 'http://localhost:5601',
    apiTimeout: 10000,
    enableDebug: true,
    enableLogging: true,
    mockApi: false,
    avatarService: 'https://ui-avatars.com/api/',
  },
  testing: {
    apiUrl: 'https://api-testing.stb.edu.pk',
    apiTimeout: 15000,
    enableDebug: true,
    enableLogging: true,
    mockApi: false,
    avatarService: 'https://ui-avatars.com/api/',
  },
  production: {
    apiUrl: 'https://api.stb.edu.pk',
    apiTimeout: 20000,
    enableDebug: false,
    enableLogging: false,
    mockApi: false,
    avatarService: 'https://ui-avatars.com/api/',
  },
};

const defaultApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5601/api/v1';

// Get current environment
const getCurrentEnv = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  return env === 'production' ? 'production' : env === 'testing' ? 'testing' : 'development';
};

// Get current configuration
const getConfig = () => {
  const env = getCurrentEnv();
  const base = config[env] || config.development;
  // Allow explicit override via REACT_APP_API_URL when needed
  let apiUrl = process.env.REACT_APP_API_URL || base.apiUrl;
  
  // Normalize the URL to prevent duplicate '/api' when using absolute or relative paths
  if (apiUrl) {
    apiUrl = apiUrl.replace(/\/api\/?$/i, '').replace(/\/$/, '');
  }
  
  return { ...base, apiUrl };
};

// Export configuration
export const environment = getConfig();
export const isDevelopment = getCurrentEnv() === 'development';
export const isTesting = getCurrentEnv() === 'testing';
export const isProduction = getCurrentEnv() === 'production';

export default environment;
